import * as React from "react";
import {cx} from "emotion";

import "./yard-sign.scss";

import {cs}                     from "@Common/react/chain-services";
import {Select}                 from "@Common/ui-components/heavy/common/design2/select/select";
import {values}                 from "@Common/utils/objects";

export const YardSign = ({calSelected, yardSignOptions, className, calOptionSet}) => cs(
    ({}) => (
        <div className={cx("yard-sign-d9y", className)}>
            <div className="header">
                <div className="title">Yard Sign Options</div>
            </div>
            <div className="card">
                <div className="select">
                    {Select({
                        list: [null, ...values(yardSignOptions)] || [],
                        itemToLabel: (o) => o == null ? "None" : o.name,
                        isSelected: (o) => calSelected ? o?.dev_key === calSelected.dev_key : o == null,
                        onChange: (o) => calOptionSet(o?.dev_key, o?.name),
                        forcedExpandLeft: true,
                        xdQaName: "Yard Sign Options",
                    })}
                </div>

                {calSelected?.dev_key && (
                    <div className="description">
                        {calSelected.description}
                    </div>
                )}
            </div>
        </div>
    )
);
